import http from 'Services/HttpService';
import { baseUrl as apiUrl } from 'Utils/envLoader';

const apiEndPoint = `${apiUrl}/cliami`;

export const getAccesses = async (userId) => {
    try {
        const { data, status } = await http.get(`${apiEndPoint}/Accesses/user/${userId}`);
        if (status !== 200) throw new Error();
        return data;
    } catch (ex) {
        throw ex;
    }
};

export const postAccesses = async (data2Send) => {
    try {
        const { data, status } = await http.post(`${apiEndPoint}/Accesses/create`, data2Send);
        if (status !== 200) throw new Error();
        return data;
    } catch (ex) {
        throw ex;
    }
};

export const deleteAccesses = async (AccessId) => {
    try {
        const { data, status } = await http.delete(`${apiEndPoint}/Accesses/delete/${AccessId}`);
        if (status !== 200) throw new Error();
        return data;
    } catch (ex) {
        throw ex;
    }
};

export const getApps = async () => {
    try {
        const { data, status } = await http.get(`${apiEndPoint}/apps`);
        if (status !== 200) throw new Error();
        return data;
    } catch (ex) {
        throw ex;
    }
};

export const getApp = async (appId) => {
    try {
        const { data, status } = await http.get(`${apiEndPoint}/apps/${appId}`);
        if (status !== 200) throw new Error();
        return data;
    } catch (ex) {
        throw ex;
    }
};

export const deleteApp = async (appId) => {
    try {
        const { data, status } = await http.delete(`${apiEndPoint}/apps/delete/${appId}`);
        if (status !== 200) throw new Error();
        return data;
    } catch (ex) {
        throw ex;
    }
};

export const getUser = async (userId) => {
    try {
        const { data, status } = await http.get(`${apiEndPoint}/users/${userId}`);
        if (status !== 200) throw new Error();
        return data;
    } catch (ex) {
        throw ex;
    }
};

export const deleteUser = async (userId) => {
    try {
        const { data, status } = await http.delete(`${apiEndPoint}/users/delete/${userId}`);
        if (status !== 200) throw new Error();
        return data;
    } catch (ex) {
        throw ex;
    }
};
